import { Product, RestaurantProfile } from "@lemmonhq/types";

export interface ImportMeta {
  env: any;
}
export const getRestaurantImageURL = (shop: RestaurantProfile) => {
  return `${
    (import.meta as unknown as ImportMeta).env.VITE_ASSETS_BUCKET_HOST
  }/${(import.meta as unknown as ImportMeta).env.VITE_ENV}/${shop.id}/images/${
    shop.welcome_screen_image
  }`;
};

export const getRestaurantLogoURL = (shop: RestaurantProfile) => {
  return `${
    (import.meta as unknown as ImportMeta).env.VITE_ASSETS_BUCKET_HOST
  }/${(import.meta as unknown as ImportMeta).env.VITE_ENV}/${shop.id}/images/${
    shop.receipt_logo
  }`;
};

export const getProductImageContainerStyle = (product: Product): string => {
  const image = product.image_list?.[0];
  const meta = image?.meta;

  if (meta?.width && meta?.height) {
    // Tailwind doesn't support dynamic aspect-ratio values, so use inline style for height
    return `
      width: 100%;
      padding-bottom: ${1 * 100}%;
    `;
  }

  // Fallback to fixed height when no meta info
  return `
    height: 400px;
  `;
};

export const getProductImageURL = (
  product: Product,
  type: "single" | "thumbnail",
) => {
  const image = product.image_list && product.image_list[0];
  if (!image) {
    return `https://upload.wikimedia.org/wikipedia/commons/3/3f/Placeholder_view_vector.svg`;
  } else {
    if (
      image.processed_filename !== image.filename ||
      image.processed_filename !== image.filename
    ) {
      return `/api/v3/images/processed/${product.restaurant_id}/${product.id}?type=${type}`;
    } else {
      return `${
        (import.meta as unknown as ImportMeta).env.VITE_ASSETS_BUCKET_HOST
      }/${(import.meta as unknown as ImportMeta).env.VITE_ENV}/${
        product.restaurant_id
      }/products/${
        type === "single"
          ? "processed_single_images"
          : "processed_thumbnail_images"
      }/${image.filename}`;
    }
  }
};
